<template>
    <div
        :class="`shrink-0 ${containerClass} ${bgColorClass} rounded-full flex items-center justify-center`"
    >
        <!-- Full Service Restaurant Icon (Dining) -->
        <svg
            v-if="
                iconType === 'full-service-restaurant' || iconType === 'dining'
            "
            :class="svgClass"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M12 4C10.2761 4 8.62279 4.68482 7.40381 5.90381C6.42307 6.88454 5.7881 8.14641 5.57736 9.5H7.62438C8.11581 7.90298 9.06939 6.47974 10.3732 5.41538C11.0932 4.82769 11.8989 4.36653 12.7561 4.04411C12.5064 4.01486 12.254 4 12 4ZM17.1452 3.73407C15.6742 2.61544 13.8688 2 12 2C9.74566 2 7.58365 2.89553 5.98959 4.48959C4.63306 5.84613 3.78239 7.61397 3.559 9.5H3C2.44784 9.5 2.00017 9.94752 2 10.4997C1.9994 12.4149 2.5488 14.2901 3.58289 15.9021C4.49941 17.3309 5.76248 18.4998 7.25 19.3027V19.5C7.25 19.9641 7.43437 20.4092 7.76256 20.7374C8.09075 21.0656 8.53587 21.25 9 21.25H15C15.4641 21.25 15.9092 21.0656 16.2374 20.7374C16.5656 20.4092 16.75 19.9641 16.75 19.5V19.3027C18.2375 18.4998 19.5006 17.3309 20.4171 15.9021C21.4512 14.2901 22.0006 12.4149 22 10.4997C21.9998 9.94752 21.5522 9.5 21 9.5H20.441C20.2176 7.61397 19.3669 5.84613 18.0104 4.48959C17.749 4.2282 17.4724 3.98559 17.1825 3.76264C17.1703 3.75283 17.1579 3.74331 17.1452 3.73407ZM15.7494 5.5C14.2511 5.49977 12.7987 6.01719 11.638 6.9647C10.8041 7.64544 10.1575 8.51814 9.74842 9.5H11.9986C12.5425 8.48138 13.2892 7.58191 14.195 6.85834C14.8358 6.34648 15.5449 5.93178 16.2992 5.62484C16.2564 5.58712 16.2132 5.55001 16.1695 5.5135C16.0298 5.50459 15.8895 5.50008 15.7494 5.5ZM17.6409 7.27032C16.8433 7.50895 16.0969 7.89891 15.4432 8.42102C15.0451 8.73901 14.6872 9.10142 14.3758 9.5H18.4226C18.3002 8.71341 18.0345 7.95779 17.6409 7.27032ZM12.6479 11.5C12.6319 11.5004 12.6159 11.5004 12.5999 11.5H8.42079C8.40764 11.5003 8.39445 11.5003 8.38122 11.5H4.06238C4.21052 12.6792 4.62013 13.8149 5.26631 14.8223C6.09359 16.1119 7.27381 17.1369 8.66667 17.7753C9.02211 17.9382 9.25 18.2934 9.25 18.6844V19.25H14.75V18.6844C14.75 18.2934 14.9779 17.9382 15.3333 17.7753C16.7262 17.1369 17.9064 16.1119 18.7337 14.8223C19.3799 13.8149 19.7895 12.6792 19.9376 11.5H12.6479Z"
                fill="currentColor"
            />
        </svg>
        <!-- travel credit icon (suitcase with $) -->
        <svg
            v-if="iconType === 'travel_credit'"
            :class="svgClass"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                d="M6.2056 12.8029C6.01671 12.284 6.28429 11.7101 6.80327 11.5212L9.78875 10.4346C10.3077 10.2457 10.8816 10.5133 11.0705 11.0323L11.4533 12.084C11.6421 12.6029 11.3746 13.1768 10.8556 13.3657L7.8701 14.4523C7.35112 14.6412 6.77728 14.3736 6.58838 13.8546L6.2056 12.8029Z"
                fill="currentColor"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M17 6V5C17 3.34315 15.6569 2 14 2H10C8.34315 2 7 3.34315 7 5V6H5C3.34315 6 2 7.34315 2 9V18C2 19.6569 3.34315 21 5 21H13C13.5523 21 14 20.5523 14 20C14 19.4477 13.5523 19 13 19H5C4.44772 19 4 18.5523 4 18V9C4 8.44772 4.44772 8 5 8H19C19.5523 8 20 8.44772 20 9V10C20 10.5523 20.4477 11 21 11C21.5523 11 22 10.5523 22 10V9C22 7.34315 20.6569 6 19 6H17ZM10 4C9.44772 4 9 4.44772 9 5V6H15V5C15 4.44772 14.5523 4 14 4H10Z"
                fill="currentColor"
            />
            <path
                d="M18.1301 22.4688V22.1172C17.4705 21.9126 16.8867 21.5254 16.4919 20.9795C16.138 20.49 16.2479 19.8051 16.7373 19.4512C17.2268 19.0972 17.9117 19.2083 18.2656 19.6978C18.3991 19.8818 18.7335 20.0968 19.2239 20.0969H19.3801C19.6943 20.0969 19.9427 19.9937 20.093 19.8735C20.2413 19.7549 20.2615 19.6544 20.2615 19.6099C20.2613 19.569 20.2276 19.406 19.9783 19.2693L19.8574 19.2119L17.7798 18.3818C16.8025 17.9909 16.0001 17.1034 16 15.9526V15.8867C16.0003 14.5645 17.0068 13.6912 18.1301 13.3928V13.0938C18.1301 12.4899 18.6201 12.0003 19.2239 12C19.8279 12 20.3176 12.4897 20.3176 13.0938V13.4429C20.9151 13.6278 21.4496 13.9644 21.8386 14.4316L21.9558 14.583L22.0168 14.677C22.2951 15.1568 22.1695 15.7794 21.7104 16.1113C21.2517 16.4426 20.6226 16.3664 20.2542 15.9526L20.1833 15.8647L20.1248 15.7952C19.9647 15.6305 19.6538 15.4656 19.2239 15.4656H18.9883C18.6964 15.4656 18.4672 15.561 18.3315 15.6694C18.1989 15.7755 18.1877 15.8595 18.1875 15.8867V15.9526C18.1877 15.9993 18.2314 16.2065 18.5916 16.3506L20.6692 17.1807L20.8511 17.26C21.7443 17.6838 22.4489 18.5312 22.449 19.6099C22.449 20.9395 21.4506 21.827 20.3176 22.1477V22.4688C20.3176 23.0728 19.8279 23.5625 19.2239 23.5625C18.6201 23.5622 18.1301 23.0726 18.1301 22.4688Z"
                fill="currentColor"
            />
        </svg>

        <!-- Airplane Up Icon (Travel/Airline) -->
        <svg
            v-if="
                iconType === 'airplane-up' ||
                iconType === 'airline' ||
                iconType === 'priority_boarding' ||
                iconType === 'seat_upgrade'
            "
            :class="svgClass"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                d="M3.47116 6.88628L2 7.41923L4.3064 10.818L4.05884 11.3464C3.83481 11.8245 3.80898 12.3719 3.98698 12.869L4.06146 13.0771C4.43936 14.1325 5.61088 14.6713 6.65815 14.2712L10.25 12.899L10.3405 14.1987C10.3867 14.8614 11.0542 15.2957 11.6787 15.0695L12.6524 14.7167C13.0412 14.5759 13.3768 14.3179 13.613 13.9785L15.75 10.9066L19.9899 9.37062C20.7644 9.09005 21.2803 8.35453 21.2803 7.5308C21.2803 6.63159 20.6674 5.84812 19.7947 5.63157L17.8511 5.14933C17.4596 5.05217 17.0487 5.07535 16.6707 5.21635C15.0634 5.81589 10.539 7.50155 8.60086 8.20366C8.04343 8.4056 7.42468 8.35067 6.91195 8.05372L5.15471 7.036C4.64322 6.73977 4.0269 6.68496 3.47116 6.88628Z"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M3 19H21"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>

        <!-- Phone/Mobile Icon -->
        <svg
            v-if="iconType === 'cell_phone_insurance'"
            :class="svgClass"
            fill="currentColor"
            viewBox="0 0 24 24"
        >
            <path
                d="M17 2H7c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM7 4h10v14H7V4z"
            />
        </svg>

        <!-- Building/Hotel Icon -->
        <svg
            v-if="iconType === 'building' || iconType === 'hotel'"
            :class="svgClass"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7 5C6.44772 5 6 5.44772 6 6V19H18V6C18 5.44772 17.5523 5 17 5H7ZM20 19V6C20 4.34315 18.6569 3 17 3H7C5.34315 3 4 4.34315 4 6V19H3C2.44772 19 2 19.4477 2 20C2 20.5523 2.44772 21 3 21H21C21.5523 21 22 20.5523 22 20C22 19.4477 21.5523 19 21 19H20ZM8 8C8 7.44772 8.44772 7 9 7H10C10.5523 7 11 7.44772 11 8C11 8.55228 10.5523 9 10 9H9C8.44772 9 8 8.55228 8 8ZM13 8C13 7.44772 13.4477 7 14 7H15C15.5523 7 16 7.44772 16 8C16 8.55228 15.5523 9 15 9H14C13.4477 9 13 8.55228 13 8ZM8 12C8 11.4477 8.44772 11 9 11H10C10.5523 11 11 11.4477 11 12C11 12.5523 10.5523 13 10 13H9C8.44772 13 8 12.5523 8 12ZM13 12C13 11.4477 13.4477 11 14 11H15C15.5523 11 16 11.4477 16 12C16 12.5523 15.5523 13 15 13H14C13.4477 13 13 12.5523 13 12ZM8 16C8 15.4477 8.44772 15 9 15H10C10.5523 15 11 15.4477 11 16C11 16.5523 10.5523 17 10 17H9C8.44772 17 8 16.5523 8 16ZM13 16C13 15.4477 13.4477 15 14 15H15C15.5523 15 16 15.4477 16 16C16 16.5523 15.5523 17 15 17H14C13.4477 17 13 16.5523 13 16Z"
                fill="currentColor"
            />
        </svg>

        <!-- Car/Transportation Icon -->
        <svg
            v-if="
                iconType === 'rideshare' ||
                iconType === 'transportation' ||
                iconType === 'car_rental'
            "
            :class="svgClass"
            fill="currentColor"
            viewBox="0 0 24 24"
        >
            <path
                d="M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.22.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11H5z"
            />
        </svg>
        <!-- credit score -->
        <svg
            v-if="iconType === 'credit_score'"
            :class="svgClass"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M12 4C7.58172 4 4 7.58172 4 12C4 13.0624 4.20658 14.0745 4.58123 15H11.382L14.1056 9.55279C14.3526 9.05881 14.9532 8.85858 15.4472 9.10557C15.9412 9.35256 16.1414 9.95324 15.8944 10.4472L13.618 15H19.4188C19.7934 14.0745 20 13.0624 20 12C20 7.58172 16.4183 4 12 4ZM18.2456 17H5.75442C7.22132 18.8299 9.47461 20 12 20C14.5254 20 16.7787 18.8299 18.2456 17ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 13.5947 21.626 15.1049 20.96 16.445C19.3249 19.7353 15.9278 22 12 22C8.07218 22 4.67514 19.7353 3.04001 16.445C2.37401 15.1049 2 13.5947 2 12Z"
                fill="currentColor"
            />
        </svg>

        <!-- Credit Card Icon -->
        <svg
            v-if="iconType === 'card' || iconType === 'credit'"
            :class="svgClass"
            fill="currentColor"
            viewBox="0 0 24 24"
        >
            <path
                d="M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z"
            />
        </svg>

        <!-- Globe/World Icon -->
        <svg
            v-if="iconType === 'globe' || iconType === 'world'"
            :class="svgClass"
            fill="currentColor"
            viewBox="0 0 24 24"
        >
            <path
                d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.94-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"
            />
        </svg>
        <!-- rental car insurance -->
        <svg
            v-if="
                iconType === 'rental_car_insurance' ||
                iconType === 'auto' ||
                iconType === 'roadside_assistance'
            "
            :class="svgClass"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M5 13C5 12.4477 5.44772 12 6 12H8C8.55228 12 9 12.4477 9 13C9 13.5523 8.55228 14 8 14H6C5.44772 14 5 13.5523 5 13ZM15 13C15 12.4477 15.4477 12 16 12H18C18.5523 12 19 12.4477 19 13C19 13.5523 18.5523 14 18 14H16C15.4477 14 15 13.5523 15 13Z"
                fill="currentColor"
            />
            <path
                d="M6.20971 6.41185C6.39789 6.1531 6.69851 6.00002 7.01845 6.00002H10.9901C11.5424 6.00002 11.9901 5.5523 11.9901 5.00002C11.9901 4.44773 11.5424 4.00002 10.9901 4.00002H7.01845C6.05864 4.00002 5.15677 4.45927 4.59224 5.2355L1.49078 9.50002H1C0.447715 9.50002 0 9.94773 0 10.5C0 11.0523 0.447715 11.5 1 11.5V17C1 18.6569 2.34315 20 4 20C5.30622 20 6.41746 19.1652 6.82929 18H17.1707C17.5825 19.1652 18.6938 20 20 20C21.6569 20 23 18.6569 23 17V13.0023C23 12.45 22.5523 12.0023 22 12.0023C21.4477 12.0023 21 12.45 21 13.0023V17C21 17.5523 20.5523 18 20 18C19.4477 18 19 17.5523 19 17C19 16.4477 18.5523 16 18 16H6C5.44772 16 5 16.4477 5 17C5 17.5523 4.55228 18 4 18C3.44772 18 3 17.5523 3 17V10.8252L6.20971 6.41185Z"
                fill="currentColor"
            />
            <path
                d="M20.667 3.81154L18.333 3.00978L16 3.81154V5.66603C16.0001 6.38124 16.2682 6.86894 16.7295 7.30568C17.1423 7.69643 17.6827 8.0212 18.333 8.37893C18.9836 8.02104 19.5245 7.6966 19.9375 7.30568C20.3988 6.86894 20.6669 6.38124 20.667 5.66603V3.81154ZM22.667 5.66603C22.6669 7.02227 22.101 8.01132 21.3125 8.75783C20.5722 9.45864 19.6095 9.96639 18.8086 10.3985C18.5123 10.5583 18.1547 10.5583 17.8584 10.3985C17.0575 9.9664 16.0948 9.45862 15.3545 8.75783C14.566 8.01132 14.0001 7.02227 14 5.66603V3.6924C14.0001 2.90973 14.4971 2.21346 15.2373 1.959L17.7373 1.09963L17.8838 1.05568C18.1789 0.981058 18.4881 0.981006 18.7832 1.05568L18.9297 1.09963L21.4297 1.959L21.5654 2.01174C22.2298 2.3008 22.6669 2.9587 22.667 3.6924V5.66603Z"
                fill="currentColor"
            />
        </svg>
        <!-- tsa icon -->
        <svg
            v-if="iconType === 'tsa'"
            :class="svgClass"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                d="M11.6865 18.4189C12.0075 17.9695 12.6316 17.8655 13.0811 18.1865C13.5305 18.5075 13.6345 19.1316 13.3135 19.5811L12.0635 21.3311C11.7425 21.7805 11.1184 21.8845 10.6689 21.5635C10.2195 21.2425 10.1155 20.6184 10.4365 20.1689L11.6865 18.4189ZM14.9268 11.0029C15.2146 10.9818 15.5001 11.086 15.707 11.293L17.4141 13H19C19.5523 13 20 13.4477 20 14C20 14.5523 19.5523 15 19 15H17C16.7348 15 16.4805 14.8946 16.293 14.707L15.7637 14.1777L15.5635 15.9854L17.1416 16.9824C17.2467 17.0703 17.3328 17.1794 17.3945 17.3027L18.8945 20.3027L18.9355 20.3965C19.1153 20.8704 18.9104 21.413 18.4473 21.6445C17.9842 21.8761 17.4276 21.7143 17.1562 21.2861L17.1055 21.1973L15.7305 18.4482L13.9697 17.3477C13.644 17.1439 13.4635 16.7716 13.5059 16.3896L13.8545 13.248L13.0693 13.4053L11.7998 15.0996C11.4685 15.5414 10.8422 15.631 10.4004 15.2998C9.95861 14.9685 9.86896 14.3422 10.2002 13.9004L11.7588 11.8291C11.9021 11.6708 12.0928 11.5618 12.3037 11.5195L14.9268 11.0029ZM16 5C16 4.73478 15.8946 4.48051 15.707 4.29297C15.5195 4.10543 15.2652 4 15 4H8C7.73478 4 7.4805 4.10543 7.29297 4.29297C7.10543 4.4805 7 4.73478 7 5V20H7.5C8.05228 20 8.5 20.4477 8.5 21C8.5 21.5523 8.05228 22 7.5 22H3C2.44772 22 2 21.5523 2 21C2 20.4477 2.44772 20 3 20H5V5C5 4.20435 5.3163 3.44152 5.87891 2.87891C6.44152 2.3163 7.20435 2 8 2H15C15.7956 2 16.5585 2.3163 17.1211 2.87891C17.6837 3.44151 18 4.20435 18 5C18 5.55228 17.5523 6 17 6C16.4477 6 16 5.55228 16 5ZM17.5 9C17.5 9.46413 17.3155 9.90912 16.9873 10.2373C16.6591 10.5655 16.2141 10.75 15.75 10.75C15.2859 10.75 14.8409 10.5655 14.5127 10.2373C14.1845 9.90912 14 9.46413 14 9C14 8.53587 14.1845 8.09088 14.5127 7.7627L14.6406 7.64648C14.9521 7.3912 15.3438 7.25 15.75 7.25L15.9229 7.25879C16.2664 7.29288 16.5924 7.42764 16.8594 7.64648L16.9873 7.7627L17.1035 7.89062C17.3588 8.20207 17.5 8.59377 17.5 9Z"
                fill="currentColor"
            />
        </svg>
        <!-- Fraud protection icon -->
        <svg
            v-if="iconType === 'fraud_protection' || iconType === 'financial'"
            :class="svgClass"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                d="M20 7C20 6.44788 19.5524 6 19 6H5C4.44772 6 4 6.44772 4 7V9H20V7ZM22 10C22 10.5523 21.5523 11 21 11H4V17C4 17.5524 4.44782 18 5 18H12C12.5523 18 13 18.4477 13 19C13 19.5523 12.5523 20 12 20H5C3.34304 20 2 18.6568 2 17V7C2 5.34315 3.34315 4 5 4H19C20.6567 4 22 5.34298 22 7V10Z"
                fill="currentColor"
            />
            <path
                d="M21.667 15.8115L19.333 15.0098L17 15.8115V17.666C17.0001 18.3812 17.2682 18.8689 17.7295 19.3057C18.1423 19.6964 18.6827 20.0212 19.333 20.3789C19.9836 20.021 20.5245 19.6966 20.9375 19.3057C21.3988 18.8689 21.6669 18.3812 21.667 17.666V15.8115ZM23.667 17.666C23.6669 19.0223 23.101 20.0113 22.3125 20.7578C21.5722 21.4586 20.6095 21.9664 19.8086 22.3984C19.5123 22.5583 19.1547 22.5583 18.8584 22.3984C18.0575 21.9664 17.0948 21.4586 16.3545 20.7578C15.566 20.0113 15.0001 19.0223 15 17.666V15.6924C15.0001 14.9097 15.4971 14.2134 16.2373 13.959L18.7373 13.0996C19.0753 12.9834 19.4389 12.9685 19.7832 13.0557L19.9297 13.0996L22.4297 13.959C23.1697 14.2135 23.6669 14.9098 23.667 15.6924V17.666Z"
                fill="currentColor"
            />
        </svg>
        <!-- travel portal icon -->
        <svg
            v-if="iconType === 'travel_portal'"
            :class="svgClass"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                d="M12 2C16.764 2 20.7481 5.33046 21.7549 9.78906C21.8764 10.3277 21.5377 10.8627 20.999 10.9844C20.4604 11.1059 19.9254 10.7681 19.8037 10.2295C19.2683 7.85816 17.6783 5.88733 15.5537 4.83203C16.2344 6.19648 16.7024 7.96541 16.8975 9.91211C16.9525 10.4616 16.5514 10.9517 16.002 11.0068C15.4526 11.0619 14.9625 10.6616 14.9072 10.1123C14.7153 8.19729 14.2432 6.58359 13.6387 5.48242C13.0042 4.32688 12.3888 4 12 4C11.7731 4 11.482 4.09945 11.1328 4.43164C10.7784 4.76891 10.4129 5.30403 10.085 6.04199C9.52351 7.30527 9.12806 9.03348 9.02637 11H11.5C12.0523 11 12.5 11.4477 12.5 12C12.5 12.5523 12.0523 13 11.5 13H9.02637C9.12806 14.9665 9.52351 16.6947 10.085 17.958C10.4129 18.696 10.7784 19.2311 11.1328 19.5684C11.482 19.9005 11.7731 20 12 20C12.5523 20 13 20.4477 13 21C13 21.5523 12.5523 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM4.06445 13C4.40263 15.7111 6.09575 17.9992 8.44629 19.167C8.38161 19.0373 8.31782 18.9055 8.25781 18.7705C7.56803 17.2185 7.1266 15.204 7.02344 13H4.06445ZM8.44629 4.83203C6.09555 5.99972 4.40265 8.28879 4.06445 11H7.02344C7.1266 8.79597 7.56803 6.7815 8.25781 5.22949C8.31794 5.09422 8.38147 4.96197 8.44629 4.83203Z"
                fill="currentColor"
            />
            <path
                d="M16.0099 15.3544L17.2549 19.9948C17.3198 20.2366 17.6445 20.2795 17.7699 20.0628L18.9585 18.0098C18.9709 17.9885 18.9885 17.9709 19.0098 17.9585L21.0628 16.7699C21.2795 16.6445 21.2366 16.3198 20.9948 16.2549L16.3544 15.0099C16.1452 14.9538 15.9538 15.1452 16.0099 15.3544Z"
                fill="currentColor"
            />
            <path
                d="M16.4365 14.0088L16.6133 14.0439L21.2539 15.2891C22.3555 15.5846 22.5505 17.0643 21.5635 17.6357L20.584 18.2021L22.2002 19.7861C22.5943 20.1727 22.6003 20.8058 22.2139 21.2002C21.8273 21.5943 21.1942 21.6003 20.7998 21.2139L19.1787 19.625L18.6357 20.5635C18.0643 21.5505 16.5846 21.3555 16.2891 20.2539L15.0439 15.6133C14.8045 14.7198 15.5563 13.8971 16.4365 14.0088ZM17.7715 18.0625L18.0928 17.5088L18.1758 17.3848C18.2663 17.2671 18.3795 17.1676 18.5088 17.0928L19.0625 16.7715L17.2979 16.2979L17.7715 18.0625Z"
                fill="currentColor"
            />
        </svg>
        <!-- Shield/Protection Icon -->
        <svg
            v-if="iconType === 'insurance' || iconType === 'protection'"
            :class="svgClass"
            fill="currentColor"
            viewBox="0 0 24 24"
        >
            <path
                d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z"
            />
        </svg>
        <!-- checked bag / luggage icon -->
        <svg
            v-if="iconType === 'luggage' || iconType === 'checked_bag'"
            :class="svgClass"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                d="M15 5C15 4.44772 14.5523 4 14 4H10C9.44772 4 9 4.44772 9 5V6H15V5ZM17 6H19C20.6569 6 22 7.34315 22 9V12C22 12.5523 21.5523 13 21 13C20.4477 13 20 12.5523 20 12V9C20 8.44771 19.5523 8 19 8H5C4.44772 8 4 8.44772 4 9V18C4 18.5523 4.44772 19 5 19H11C11.5523 19 12 19.4477 12 20C12 20.5523 11.5523 21 11 21H5C3.34315 21 2 19.6569 2 18V9C2 7.34315 3.34315 6 5 6H7V5C7 3.34315 8.34315 2 10 2H14C15.6569 2 17 3.34315 17 5V6Z"
                fill="currentColor"
            />
            <path
                d="M21.3689 15.2244C21.7617 14.904 22.3407 14.9266 22.7068 15.2927C23.0729 15.6589 23.0955 16.2379 22.7752 16.6306L22.7068 16.7068L18.2068 21.2068C17.8407 21.5729 17.2617 21.5955 16.8689 21.2752L16.7927 21.2068L14.5427 18.9568L14.4744 18.8806C14.154 18.4879 14.1766 17.9088 14.5427 17.5427C14.9088 17.1766 15.4879 17.154 15.8806 17.4744L15.9568 17.5427L17.4998 19.0857L21.2927 15.2927L21.3689 15.2244Z"
                fill="currentColor"
            />
        </svg>
        <!-- concierge -->
        <svg
            v-if="iconType === 'concierge'"
            :class="svgClass"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                d="M18.9978 16C18.9978 10.9791 15.7933 8 11.9978 8C8.20229 8 4.9978 10.9791 4.9978 16H18.9978ZM20.9978 17C20.9978 17.5523 20.5501 18 19.9978 18H12.9998V19H19.9978C20.5501 19 20.9978 19.4477 20.9978 20C20.9978 20.5523 20.5501 21 19.9978 21H3.9978C3.44552 21 2.9978 20.5523 2.9978 20C2.9978 19.4477 3.44552 19 3.9978 19H10.9998V18H3.9978C3.44552 18 2.9978 17.5523 2.9978 17V16C2.9978 10.4217 6.44397 6.54892 10.9998 6.05469V5H9.99976C9.44758 4.99987 8.99976 4.5522 8.99976 4C8.99976 3.4478 9.44758 3.00013 9.99976 3H13.9998C14.552 3 14.9998 3.44772 14.9998 4C14.9998 4.55228 14.552 5 13.9998 5H12.9998V6.05566C17.5536 6.55171 20.9978 10.4233 20.9978 16V17Z"
                fill="currentColor"
            />
        </svg>
        <!-- companion pass -->
        <svg
            v-if="iconType === 'companion_certificate'"
            :class="svgClass"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                d="M9.37353 12.0068C13.2223 12.1474 16.5377 14.4499 17.6284 17.7178L17.6782 17.8857C17.8956 18.7252 17.6352 19.5179 17.1274 20.0801C16.6359 20.6242 15.9181 20.9566 15.1538 20.9961L14.9995 21H2.99951C2.17848 20.9999 1.39691 20.6605 0.872552 20.0801C0.330923 19.4805 0.0708668 18.6188 0.371575 17.7178L0.48388 17.4043C1.71632 14.2003 5.11848 12.0001 8.99951 12L9.37353 12.0068ZM17.0571 13.1748C17.23 12.6867 17.7434 12.4169 18.2358 12.5371L18.3335 12.5664L18.7964 12.7441C21.0801 13.689 22.8805 15.4767 23.6284 17.7178L23.6782 17.8857C23.8956 18.7252 23.6353 19.5179 23.1274 20.0801C22.6358 20.6241 21.918 20.9566 21.1538 20.9961L20.9995 21H20.4995C19.9474 20.9998 19.4995 20.5521 19.4995 20C19.4995 19.4478 19.9474 19.0002 20.4995 19H20.9995L21.104 18.9941C21.3401 18.9692 21.532 18.8621 21.6431 18.7393C21.7254 18.6481 21.7613 18.5577 21.7534 18.4561L21.7319 18.3506C21.1902 16.7275 19.848 15.343 18.0347 14.5928L17.6665 14.4512L17.5718 14.4121C17.1134 14.1955 16.8842 13.6629 17.0571 13.1748ZM8.69482 14.0059C5.66703 14.1164 3.2212 15.8639 2.35009 18.123L2.26806 18.3506C2.21917 18.4971 2.24658 18.618 2.35595 18.7393C2.48285 18.8797 2.71627 18.9999 2.99951 19H14.9995L15.104 18.9941C15.34 18.9692 15.532 18.8621 15.6431 18.7393C15.7254 18.6481 15.7613 18.5577 15.7534 18.4561L15.7319 18.3506C14.9159 15.9057 12.2696 14 8.99951 14L8.69482 14.0059ZM11.4995 6.5C11.4995 5.11929 10.3802 4 8.99951 4C7.61897 4.00021 6.49951 5.11941 6.49951 6.5C6.49951 7.88059 7.61897 8.99979 8.99951 9C10.3802 9 11.4995 7.88071 11.4995 6.5ZM17.4995 6.5C17.4995 5.20553 16.5161 4.14065 15.2554 4.0127L14.9995 4L14.8979 3.99512C14.3935 3.94406 13.9995 3.51788 13.9995 3C13.9995 2.44784 14.4474 2.00021 14.9995 2L15.2319 2.00586C17.6094 2.12662 19.4995 4.09254 19.4995 6.5C19.4995 8.98528 17.4848 11 14.9995 11C14.4474 10.9998 13.9995 10.5522 13.9995 10C13.9995 9.44784 14.4474 9.00021 14.9995 9C16.3802 9 17.4995 7.88071 17.4995 6.5ZM13.4995 6.5C13.4995 8.98528 11.4848 11 8.99951 11C6.5144 10.9998 4.49951 8.98516 4.49951 6.5C4.49951 4.01485 6.5144 2.00021 8.99951 2C11.4848 2 13.4995 4.01472 13.4995 6.5Z"
                fill="currentColor"
            />
        </svg>
        <!-- Star/Premium Icon -->
        <svg
            v-if="iconType === 'status' || iconType === 'premium'"
            :class="svgClass"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                d="M15.7147 3C16.4688 3.00003 17.1957 3.28439 17.7499 3.7959L22.1454 7.85352L22.2587 7.96387C23.3984 9.13097 23.3986 11.0114 22.2313 12.1787L14.118 20.293C12.9831 21.4279 11.1648 21.4634 9.98718 20.3994L9.87488 20.293L1.7616 12.1787C0.556903 10.974 0.595805 9.00925 1.84754 7.85352L6.24402 3.7959L6.45886 3.61426C6.97942 3.21719 7.61836 3.00007 8.2782 3H15.7147ZM8.2782 5C8.0582 5.00007 7.84527 5.07262 7.67175 5.20508L7.60046 5.26562L3.20398 9.32324C2.78705 9.70852 2.77422 10.3632 3.17566 10.7646L11.2899 18.8789L11.3651 18.9473C11.7579 19.2678 12.3378 19.2451 12.704 18.8789L20.8173 10.7646C21.1937 10.3882 21.2059 9.7893 20.8622 9.39844L20.7889 9.32324L16.3925 5.26562C16.2078 5.09515 15.9661 5.00003 15.7147 5H8.2782ZM8.78992 7.29297C9.18046 6.90264 9.81352 6.90251 10.204 7.29297C10.5942 7.68344 10.5942 8.31656 10.204 8.70703L8.91101 10L10.204 11.293L10.2723 11.3691C10.5925 11.7618 10.5699 12.341 10.204 12.707C9.83775 13.0733 9.25789 13.096 8.86511 12.7754L8.78992 12.707L6.78992 10.707C6.39939 10.3165 6.39939 9.68349 6.78992 9.29297L8.78992 7.29297Z"
                fill="currentColor"
            />
        </svg>

        <!-- Diamond/Luxury Icon -->
        <svg
            v-if="iconType === 'diamond' || iconType === 'luxury'"
            :class="svgClass"
            fill="currentColor"
            viewBox="0 0 24 24"
        >
            <path
                d="M6.76 4.84l-1.8-1.79-1.41 1.41 1.79 1.79 1.42-1.41zM4 10.5H1v2h3v-2zm9-9.95h-2V3.5h2V.55zm7.45 3.91l-1.41-1.41-1.79 1.79 1.41 1.41 1.79-1.79zm-3.21 13.7l1.79 1.8 1.41-1.41-1.8-1.79-1.4 1.4zM20 10.5v2h3v-2h-3zm-8-5c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm-1 16.95h2V19.5h-2v2.95zm-7.45-3.91l1.41 1.41 1.79-1.8-1.41-1.41-1.79 1.8z"
            />
        </svg>

        <!-- Database/Storage Icon -->
        <svg
            v-if="iconType === 'database' || iconType === 'storage'"
            :class="svgClass"
            fill="currentColor"
            viewBox="0 0 24 24"
        >
            <path
                d="M12 3C7.58 3 4 4.79 4 7s3.58 4 8 4 8-1.79 8-4-3.58-4-8-4zM4 9v3c0 2.21 3.58 4 8 4s8-1.79 8-4V9c0 2.21-3.58 4-8 4s-8-1.79-8-4zm0 5v3c0 2.21 3.58 4 8 4s8-1.79 8-4v-3c0 2.21-3.58 4-8 4s-8-1.79-8-4z"
            />
        </svg>

        <!-- Briefcase/Business Icon -->
        <svg
            v-if="iconType === 'briefcase' || iconType === 'business'"
            :class="svgClass"
            fill="currentColor"
            viewBox="0 0 24 24"
        >
            <path
                d="M10 16V8c0-1.1.9-2 2-2s2 .9 2 2v8h5V6c0-1.1-.9-2-2-2h-3V2c0-1.1-.9-2-2-2h-4c-1.1 0-2 .9-2 2v2H3c-1.1 0-2 .9-2 2v10h9zm2-12h4v2h-4V4z"
            />
        </svg>

        <!-- Gym/Fitness Icon -->
        <svg
            v-if="iconType === 'gym' || iconType === 'fitness'"
            :class="svgClass"
            fill="currentColor"
            viewBox="0 0 24 24"
        >
            <path
                d="M20.57 14.86L22 13.43 20.57 12 17 15.57 8.43 7 12 3.43 10.57 2 9.14 3.43 7.71 2 5.57 4.14 4.14 2.71 2.71 4.14l1.43 1.43L2 7.71l1.43 1.43L2 10.57 3.43 12 7 8.43 15.57 17 12 20.57 13.43 22l1.43-1.43L16.29 22l2.14-2.14 1.43 1.43 1.43-1.43-1.43-1.43L22 16.29l-1.43-1.43z"
            />
        </svg>

        <!-- Percentage/Discount Icon -->
        <svg
            v-if="iconType === 'percentage' || iconType === 'discount'"
            :class="svgClass"
            fill="currentColor"
            viewBox="0 0 24 24"
        >
            <path
                d="M7.5 4C5.57 4 4 5.57 4 7.5S5.57 11 7.5 11 11 9.43 11 7.5 9.43 4 7.5 4zm0 5C6.67 9 6 8.33 6 7.5S6.67 6 7.5 6 9 6.67 9 7.5 8.33 9 7.5 9zM16.5 13c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5 3.5-1.57 3.5-3.5-1.57-3.5-3.5-3.5zm0 5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5.41 20L4 18.59 18.59 4 20 5.41 5.41 20z"
            />
        </svg>

        <!-- Folder/Documents Icon -->
        <svg
            v-if="iconType === 'folder' || iconType === 'documents'"
            :class="svgClass"
            fill="currentColor"
            viewBox="0 0 24 24"
        >
            <path
                d="M10 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2h-8l-2-2z"
            />
        </svg>

        <!-- Headphones/Audio Icon -->
        <svg
            v-if="iconType === 'headphones' || iconType === 'audio'"
            :class="svgClass"
            fill="currentColor"
            viewBox="0 0 24 24"
        >
            <path
                d="M12 1c-4.97 0-9 4.03-9 9v7c0 1.66 1.34 3 3 3h3v-8H5v-2c0-3.87 3.13-7 7-7s7 3.13 7 7v2h-4v8h3c1.66 0 3-1.34 3-3v-7c0-4.97-4.03-9-9-9z"
            />
        </svg>

        <!-- Bed/Hotel Room Icon -->
        <svg
            v-if="iconType === 'bed' || iconType === 'room'"
            :class="svgClass"
            fill="currentColor"
            viewBox="0 0 24 24"
        >
            <path
                d="M21 10.78V8c0-1.65-1.35-3-3-3h-4c-.77 0-1.47.3-2 .78-.53-.48-1.23-.78-2-.78H6C4.35 5 3 6.35 3 8v2.78c-.61.55-1 1.34-1 2.22v6h2v-2h16v2h2v-6c0-.88-.39-1.67-1-2.22zM14 7h4c.55 0 1 .45 1 1v2h-6V8c0-.55.45-1 1-1zM5 8c0-.55.45-1 1-1h4c.55 0 1 .45 1 1v2H5V8zm-1 5h16v2H4v-2z"
            />
        </svg>

        <!-- Headset/Support Icon -->
        <svg
            v-if="iconType === 'headset' || iconType === 'support'"
            :class="svgClass"
            fill="currentColor"
            viewBox="0 0 24 24"
        >
            <path
                d="M12 1c-4.97 0-9 4.03-9 9v7c0 1.66 1.34 3 3 3h3v-8H5v-2c0-3.87 3.13-7 7-7s7 3.13 7 7v2h-4v8h4v1h-7v2h6c1.66 0 3-1.34 3-3V10c0-4.97-4.03-9-9-9z"
            />
        </svg>

        <!-- Dollar Sign Icon -->
        <svg
            v-if="iconType === 'dollar' || iconType === 'currency'"
            :class="svgClass"
            fill="currentColor"
            viewBox="0 0 24 24"
        >
            <path
                d="M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z"
            />
        </svg>

        <!-- Cash Back Icon -->
        <svg
            v-if="iconType === 'cashback'"
            :class="svgClass"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
        >
            <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1"
            />
        </svg>

        <!-- Shopping Icon -->
        <svg
            v-if="iconType === 'retail'"
            :class="svgClass"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
        >
            <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M16 11V7a4 4 0 00-8 0v4M5 9h14l-1 12H6L5 9z"
            />
        </svg>

        <!-- Gas Icon -->
        <svg
            v-if="iconType === 'gas'"
            :class="svgClass"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
        >
            <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
            />
        </svg>

        <!-- TV Icon (Entertainment/Streaming) -->
        <svg
            v-if="iconType === 'tv' || iconType === 'entertainment'"
            :class="svgClass"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
        >
            <rect
                x="2"
                y="3"
                width="20"
                height="14"
                rx="2"
                ry="2"
                stroke-width="2"
            />
            <line x1="8" y1="21" x2="16" y2="21" stroke-width="2" />
            <line x1="12" y1="17" x2="12" y2="21" stroke-width="2" />
        </svg>

        <!-- Credit Icon -->
        <svg
            v-if="iconType === 'credit'"
            :class="svgClass"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
        >
            <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"
            />
        </svg>

        <!-- Lounge Icon -->
        <svg
            v-if="iconType === 'lounge'"
            :class="svgClass"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                d="M5 21C4.71667 21 4.47933 20.904 4.288 20.712C4.09667 20.52 4.00067 20.2827 4 20V19C3.16667 19 2.45833 18.7083 1.875 18.125C1.29167 17.5417 1 16.8333 1 16V11C1 10.1667 1.29167 9.45833 1.875 8.875C2.45833 8.29167 3.16667 8 4 8V6C4 5.16667 4.29167 4.45833 4.875 3.875C5.45833 3.29167 6.16667 3 7 3H17C17.8333 3 18.5417 3.29167 19.125 3.875C19.7083 4.45833 20 5.16667 20 6V8C20.8333 8 21.5417 8.29167 22.125 8.875C22.7083 9.45833 23 10.1667 23 11V16C23 16.8333 22.7083 17.5417 22.125 18.125C21.5417 18.7083 20.8333 19 20 19V20C20 20.2833 19.904 20.521 19.712 20.713C19.52 20.905 19.2827 21.0007 19 21C18.7173 20.9993 18.48 20.9033 18.288 20.712C18.096 20.5207 18 20.2833 18 20V19H6V20C6 20.2833 5.904 20.521 5.712 20.713C5.52 20.905 5.28267 21.0007 5 21ZM4 17H20C20.2833 17 20.521 16.904 20.713 16.712C20.905 16.52 21.0007 16.2827 21 16V11C21 10.7167 20.904 10.4793 20.712 10.288C20.52 10.0967 20.2827 10.0007 20 10C19.7173 9.99933 19.48 10.0953 19.288 10.288C19.096 10.4807 19 10.718 19 11V15H5V11C5 10.7167 4.904 10.4793 4.712 10.288C4.52 10.0967 4.28267 10.0007 4 10C3.71733 9.99933 3.48 10.0953 3.288 10.288C3.096 10.4807 3 10.718 3 11V16C3 16.2833 3.096 16.521 3.288 16.713C3.48 16.905 3.71733 17.0007 4 17ZM7 13H17V11C17 10.55 17.0917 10.1417 17.275 9.775C17.4583 9.40833 17.7 9.08333 18 8.8V6C18 5.71667 17.904 5.47933 17.712 5.288C17.52 5.09667 17.2827 5.00067 17 5H7C6.71667 5 6.47933 5.096 6.288 5.288C6.09667 5.48 6.00067 5.71733 6 6V8.8C6.3 9.08333 6.54167 9.40833 6.725 9.775C6.90833 10.1417 7 10.55 7 11V13Z"
                fill="currentColor"
            />
        </svg>

        <!-- Streaming Icon -->
        <svg
            v-if="iconType === 'streaming'"
            :class="svgClass"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
        >
            <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M14.828 14.828a4 4 0 01-5.656 0M9 10h1m4 0h1m-6 4h.01M16 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
        </svg>
        <!-- transfer points -->
        <svg
            v-if="iconType === 'transfer_points'"
            :class="svgClass"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                d="M18 13V12.166C17.7725 12.2729 17.5335 12.3716 17.2861 12.46C15.8857 12.9601 14.0165 13.25 12 13.25C9.98346 13.25 8.11434 12.9601 6.71387 12.46C6.46652 12.3716 6.22753 12.2729 6 12.166V13.9824C6.00647 14.0016 6.04116 14.0788 6.19531 14.209C6.42465 14.4026 6.81586 14.6223 7.38672 14.8262C8.51973 15.2308 10.1507 15.5 12 15.5C12.5523 15.5 13 15.9477 13 16.5C13 17.0523 12.5523 17.5 12 17.5C9.98346 17.5 8.11434 17.2101 6.71387 16.71C6.46652 16.6216 6.22753 16.5229 6 16.416V18.4824C6.00647 18.5016 6.04116 18.5788 6.19531 18.709C6.42465 18.9026 6.81586 19.1223 7.38672 19.3262C8.51973 19.7308 10.1507 20 12 20C12.5523 20 13 20.4477 13 21C13 21.5523 12.5523 22 12 22C9.98346 22 8.11434 21.7101 6.71387 21.21C6.0181 20.9615 5.38435 20.6417 4.90527 20.2373C4.43081 19.8367 4 19.2537 4 18.5V5.5C4 4.74631 4.43081 4.16333 4.90527 3.7627C5.38435 3.35825 6.0181 3.03853 6.71387 2.79004C8.11434 2.28989 9.98346 2 12 2C14.0165 2 15.8857 2.28989 17.2861 2.79004C17.9819 3.03853 18.6157 3.35825 19.0947 3.7627C19.5692 4.16333 20 4.74631 20 5.5V13C20 13.5523 19.5523 14 19 14C18.4477 14 18 13.5523 18 13ZM18 7.91602C17.7725 8.02288 17.5335 8.12162 17.2861 8.20996C15.8857 8.71011 14.0165 9 12 9C9.98346 9 8.11434 8.71011 6.71387 8.20996C6.46652 8.12162 6.22753 8.02288 6 7.91602V9.73242C6.00647 9.75162 6.04116 9.82882 6.19531 9.95898C6.42465 10.1526 6.81586 10.3723 7.38672 10.5762C8.51973 10.9808 10.1507 11.25 12 11.25C13.8493 11.25 15.4803 10.9808 16.6133 10.5762C17.1841 10.3723 17.5754 10.1526 17.8047 9.95898C17.9588 9.82882 17.9935 9.75162 18 9.73242V7.91602ZM12 4C10.1507 4 8.51973 4.26921 7.38672 4.67383C6.81586 4.87771 6.42465 5.09737 6.19531 5.29102C6.07074 5.3962 6.02381 5.46673 6.00684 5.5C6.02381 5.53327 6.07074 5.6038 6.19531 5.70898C6.42465 5.90263 6.81586 6.12229 7.38672 6.32617C8.51973 6.73079 10.1507 7 12 7C13.8493 7 15.4803 6.73079 16.6133 6.32617C17.1841 6.12229 17.5754 5.90263 17.8047 5.70898C17.9288 5.60422 17.975 5.53344 17.9922 5.5C17.975 5.46656 17.9288 5.39578 17.8047 5.29102C17.5754 5.09737 17.1841 4.87771 16.6133 4.67383C15.4803 4.26921 13.8493 4 12 4Z"
                fill="currentColor"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M19.7389 15.4792C19.3833 15.0567 18.7525 15.0024 18.3299 15.358C17.9073 15.7136 17.8531 16.3445 18.2087 16.767L19.2464 18.0001H15.003C14.4507 18.0001 14.003 18.4478 14.003 19.0001C14.003 19.5524 14.4507 20.0001 15.003 20.0001H19.2464L18.2087 21.2331C17.8531 21.6557 17.9073 22.2865 18.3299 22.6421C18.7525 22.9978 19.3833 22.9435 19.7389 22.5209L22.1601 19.644C22.4733 19.2718 22.4733 18.7283 22.1601 18.3562L19.7389 15.4792Z"
                fill="currentColor"
            />
        </svg>

        <!-- travel insurance icon -->
        <svg
            v-if="iconType === 'trip_insurance'"
            :class="svgClass"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                d="M6.2056 12.8029C6.01671 12.284 6.28429 11.7101 6.80327 11.5212L9.78875 10.4346C10.3077 10.2457 10.8816 10.5133 11.0705 11.0323L11.4533 12.084C11.6421 12.6029 11.3746 13.1768 10.8556 13.3657L7.8701 14.4523C7.35112 14.6412 6.77728 14.3736 6.58838 13.8546L6.2056 12.8029Z"
                fill="currentColor"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M17 6V5C17 3.34315 15.6569 2 14 2H10C8.34315 2 7 3.34315 7 5V6H5C3.34315 6 2 7.34315 2 9V18C2 19.6569 3.34315 21 5 21H11C11.5523 21 12 20.5523 12 20C12 19.4477 11.5523 19 11 19H5C4.44772 19 4 18.5523 4 18V9C4 8.44772 4.44772 8 5 8H19C19.5523 8 20 8.44772 20 9V11C20 11.5523 20.4477 12 21 12C21.5523 12 22 11.5523 22 11V9C22 7.34315 20.6569 6 19 6H17ZM10 4C9.44772 4 9 4.44772 9 5V6H15V5C15 4.44772 14.5523 4 14 4H10Z"
                fill="currentColor"
            />
            <path
                d="M20.667 15.8118L18.333 15.0101L16 15.8118V17.6663C16.0001 18.3815 16.2682 18.8692 16.7295 19.306C17.1423 19.6967 17.6827 20.0215 18.333 20.3792C18.9836 20.0213 19.5245 19.6969 19.9375 19.306C20.3988 18.8692 20.6669 18.3815 20.667 17.6663V15.8118ZM22.667 17.6663C22.6669 19.0226 22.101 20.0116 21.3125 20.7581C20.5722 21.4589 19.6095 21.9667 18.8086 22.3988C18.5123 22.5586 18.1547 22.5586 17.8584 22.3988C17.0575 21.9667 16.0948 21.4589 15.3545 20.7581C14.566 20.0116 14.0001 19.0226 14 17.6663V15.6927C14.0001 14.91 14.4971 14.2138 15.2373 13.9593L17.7373 13.0999L17.8838 13.056C18.1789 12.9814 18.4881 12.9813 18.7832 13.056L18.9297 13.0999L21.4297 13.9593L21.5654 14.012C22.2298 14.3011 22.6669 14.959 22.667 15.6927V17.6663Z"
                fill="currentColor"
            />
        </svg>

        <!-- shipping icon -->
        <svg
            v-if="iconType === 'shipping'"
            :class="svgClass"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M6.16146 4H17.8385C18.3657 3.99998 18.8205 3.99997 19.195 4.03057C19.5904 4.06287 19.9836 4.13419 20.362 4.32698C20.9265 4.6146 21.3854 5.07354 21.673 5.63803C21.8658 6.01641 21.9371 6.40963 21.9694 6.80497C22 7.17954 22 7.6343 22 8.16143V15.8386C22 16.3657 22 16.8205 21.9694 17.195C21.9371 17.5904 21.8658 17.9836 21.673 18.362C21.3854 18.9265 20.9265 19.3854 20.362 19.673C19.9836 19.8658 19.5904 19.9371 19.195 19.9694C18.8205 20 18.3657 20 17.8385 20H6.16148C5.63432 20 5.17955 20 4.80497 19.9694C4.40963 19.9371 4.01641 19.8658 3.63803 19.673C3.07354 19.3854 2.6146 18.9265 2.32698 18.362C2.13419 17.9836 2.06287 17.5904 2.03057 17.195C1.99997 16.8205 1.99998 16.3657 2 15.8385V8.16146C1.99998 7.63431 1.99997 7.17955 2.03057 6.80497C2.06287 6.40963 2.13419 6.01641 2.32698 5.63803C2.6146 5.07354 3.07354 4.6146 3.63803 4.32698C4.01641 4.13419 4.40963 4.06287 4.80497 4.03057C5.17955 3.99997 5.63431 3.99998 6.16146 4ZM5.04593 6.01825L11.3668 11.1898C11.7351 11.4912 12.2649 11.4912 12.6332 11.1898L18.9541 6.01825C18.6807 6.00065 18.3251 6 17.8 6H6.2C5.67492 6 5.31927 6.00065 5.04593 6.01825ZM19.9993 7.7472L13.8997 12.7378C12.7946 13.6419 11.2054 13.6419 10.1003 12.7378L4.00072 7.7472C4.00007 7.88284 4 8.03283 4 8.2V15.8C4 16.3766 4.00078 16.7488 4.02393 17.0322C4.04612 17.3038 4.0838 17.4045 4.109 17.454C4.20487 17.6421 4.35785 17.7951 4.54601 17.891C4.59546 17.9162 4.69617 17.9539 4.96784 17.9761C5.25117 17.9992 5.62345 18 6.2 18H17.8C18.3766 18 18.7488 17.9992 19.0322 17.9761C19.3038 17.9539 19.4045 17.9162 19.454 17.891C19.6422 17.7951 19.7951 17.6422 19.891 17.454C19.9162 17.4045 19.9539 17.3038 19.9761 17.0322C19.9992 16.7488 20 16.3766 20 15.8V8.2C20 8.03283 19.9999 7.88284 19.9993 7.7472Z"
                fill="currentColor"
            />
        </svg>

        <svg
            v-if="iconType === 'rewards'"
            :class="svgClass"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M12.5 2C13.0523 2 13.5 2.44772 13.5 3V4.5606C14.7161 4.82276 15.7569 5.55404 16.3822 6.56481C16.6727 7.03448 16.5275 7.65077 16.0579 7.94133C15.5882 8.23189 14.9719 8.08669 14.6813 7.61701C14.2621 6.93939 13.4562 6.45455 12.5 6.45455H12.1111C10.8809 6.45455 10 7.37145 10 8.36364V8.48853C10 9.22247 10.4445 9.9351 11.2171 10.2963L14.6299 11.8919C16.0558 12.5585 17 13.947 17 15.5115C17 17.5476 15.4469 19.1519 13.5 19.4827V21C13.5 21.5523 13.0523 22 12.5 22C11.9477 22 11.5 21.5523 11.5 21V19.4394C10.2839 19.1772 9.24312 18.446 8.61782 17.4352C8.32726 16.9655 8.47246 16.3492 8.94213 16.0587C9.41181 15.7681 10.0281 15.9133 10.3187 16.383C10.7379 17.0606 11.5438 17.5455 12.5 17.5455H12.7553C14.0593 17.5455 15 16.5726 15 15.5115C15 14.7775 14.5555 14.0649 13.7829 13.7037L10.3701 12.1081L10.7936 11.2022L10.3701 12.1081C8.94423 11.4415 8 10.053 8 8.48853V8.36364C8 6.35071 9.56454 4.77566 11.5 4.49808V3C11.5 2.44772 11.9477 2 12.5 2Z"
                fill="currentColor"
            />
        </svg>
        <!-- Grocery Icon -->
        <svg
            v-if="iconType === 'grocery'"
            :class="svgClass"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
        >
            <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M3 3h2l.4 2M7 13h10l4-8H5.4m0 0L7 13m0 0l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17M17 13v6a2 2 0 01-2 2H9a2 2 0 01-2-2v-6m8 0V9a2 2 0 00-2-2H9a2 2 0 00-2 2v4.01"
            />
        </svg>

        <!-- Fallback: Sparkle/Rewards icon for any unmatched iconType -->
        <svg
            v-if="!iconType || iconType === 'other' || !hasMatchedIcon"
            :class="svgClass"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M12.5 2C13.0523 2 13.5 2.44772 13.5 3V4.5606C14.7161 4.82276 15.7569 5.55404 16.3822 6.56481C16.6727 7.03448 16.5275 7.65077 16.0579 7.94133C15.5882 8.23189 14.9719 8.08669 14.6813 7.61701C14.2621 6.93939 13.4562 6.45455 12.5 6.45455H12.1111C10.8809 6.45455 10 7.37145 10 8.36364V8.48853C10 9.22247 10.4445 9.9351 11.2171 10.2963L14.6299 11.8919C16.0558 12.5585 17 13.947 17 15.5115C17 17.5476 15.4469 19.1519 13.5 19.4827V21C13.5 21.5523 13.0523 22 12.5 22C11.9477 22 11.5 21.5523 11.5 21V19.4394C10.2839 19.1772 9.24312 18.446 8.61782 17.4352C8.32726 16.9655 8.47246 16.3492 8.94213 16.0587C9.41181 15.7681 10.0281 15.9133 10.3187 16.383C10.7379 17.0606 11.5438 17.5455 12.5 17.5455H12.7553C14.0593 17.5455 15 16.5726 15 15.5115C15 14.7775 14.5555 14.0649 13.7829 13.7037L10.3701 12.1081L10.7936 11.2022L10.3701 12.1081C8.94423 11.4415 8 10.053 8 8.48853V8.36364C8 6.35071 9.56454 4.77566 11.5 4.49808V3C11.5 2.44772 11.9477 2 12.5 2Z"
                fill="currentColor"
            />
        </svg>
    </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
    icon: {
        type: String,
        default: null,
    },
    category: {
        type: String,
        default: null,
    },
    title: {
        type: String,
        default: null,
    },
    description: {
        type: String,
        default: null,
    },
    svgClass: {
        type: String,
        default: 'w-6 h-6 text-orange dark:text-slate-300',
    },
    containerClass: {
        type: String,
        default: 'w-12 h-12 p-3',
    },
    bgColorClass: {
        type: String,
        default: 'bg-slate-100 dark:bg-slate-700',
    },
});

// Computed icon type based on available props
// Prefer category prop (unless 'other'), fall back to description-based detection
const iconType = computed(() => {
    if (
        props.category &&
        props.category !== 'other' &&
        props.category !== 'travel' &&
        props.category !== 'status'
    ) {
        return props.category;
    }
    // For 'travel' category, use description-based icon or fall back to 'airline'
    if (props.category === 'travel') {
        return iconFromDescription.value || 'airline';
    }
    return iconFromDescription.value || props.category;
});

const iconFromDescription = computed(() => {
    const str =
        (props.title || '').toLowerCase() +
        ' ' +
        (props.description || '').toLowerCase();

    // TSA/PreCheck patterns (check first, more specific)
    if (
        str.includes('tsa') ||
        str.includes('precheck') ||
        str.includes('global entry') ||
        str.includes('nexus')
    ) {
        return 'tsa';
    }

    // Lounge patterns
    if (str.includes('lounge') || str.includes('priority pass')) {
        return 'lounge';
    }

    // Hotel patterns
    if (
        str.includes('hotel') ||
        str.includes('resort') ||
        str.includes('free night') ||
        str.includes('anniversary night') ||
        str.includes('ihg') ||
        str.includes('marriott') ||
        str.includes('hilton') ||
        str.includes('hyatt')
    ) {
        return 'hotel';
    }

    // Airline patterns
    if (
        str.includes('airline') ||
        str.includes('flight') ||
        str.includes('baggage') ||
        str.includes('checked bag') ||
        str.includes('seat_upgrade') ||
        str.includes('priority_boarding')
    ) {
        return 'airline';
    }

    // Luggage patterns
    if (str.includes('luggage') || str.includes('baggage delay')) {
        return 'luggage';
    }

    // Status patterns
    if (
        str.includes('status') ||
        str.includes('elite') ||
        str.includes('a-list') ||
        str.includes('diamond') ||
        str.includes('platinum')
    ) {
        return 'status';
    }

    // Dining patterns
    if (
        str.includes('dining') ||
        str.includes('restaurant') ||
        str.includes('doordash') ||
        str.includes('uber eats')
    ) {
        return 'dining';
    }

    // Rideshare patterns
    if (
        str.includes('rideshare') ||
        str.includes('lyft') ||
        str.includes('uber')
    ) {
        return 'rideshare';
    }

    // Rental car patterns (including brand names)
    if (
        (str.includes('rental') &&
            (str.includes('car') || str.includes('auto'))) ||
        str.includes('hertz') ||
        str.includes('alamo') ||
        str.includes('avis')
    ) {
        return 'car_rental';
    }

    // Insurance/Protection patterns
    if (
        str.includes('insurance') ||
        str.includes('protection') ||
        str.includes('coverage') ||
        str.includes('warranty')
    ) {
        return 'insurance';
    }

    // Entertainment patterns
    if (
        str.includes('entertainment') ||
        str.includes('tv') ||
        str.includes('music') ||
        str.includes('streaming') ||
        str.includes('stubhub') ||
        str.includes('apple tv')
    ) {
        return 'entertainment';
    }

    // Concierge patterns
    if (str.includes('concierge') || str.includes('travel designer')) {
        return 'concierge';
    }

    // Travel credit patterns
    if (str.includes('travel credit') || str.includes('travel')) {
        return 'travel_credit';
    }

    // Companion certificate patterns
    if (str.includes('companion') || str.includes('certificate')) {
        return 'companion_certificate';
    }

    // Credit score patterns
    if (str.includes('credit reporting') || str.includes('credit score')) {
        return 'credit_score';
    }

    // Shipping patterns
    if (str.includes('shipping') || str.includes('shipt')) {
        return 'shipping';
    }

    // Business patterns
    if (str.includes('business credit')) {
        return 'business';
    }

    // Emergency patterns
    if (str.includes('fraud') || str.includes('emergency')) {
        return 'protection';
    }

    // Rewards patterns
    if (str.includes('reward')) {
        return 'rewards';
    }

    // Financing patterns
    if (str.includes('financing')) {
        return 'dollar';
    }

    // Check-in patterns
    if (str.includes('check-in') || str.includes('priority boarding')) {
        return 'airline';
    }

    // Events patterns
    if (str.includes('events')) {
        return 'entertainment';
    }

    // Deals patterns
    if (str.includes('deals')) {
        return 'discount';
    }

    // Merchants patterns
    if (str.includes('merchants')) {
        return 'retail';
    }

    return null;
});

// List of all supported icon types - used for fallback detection
const supportedIconTypes = [
    'full-service-restaurant',
    'dining',
    'travel_credit',
    'airplane-up',
    'airline',
    'priority_boarding',
    'seat_upgrade',
    'cell_phone_insurance',
    'building',
    'hotel',
    'rideshare',
    'transportation',
    'car_rental',
    'credit_score',
    'card',
    'credit',
    'globe',
    'world',
    'rental_car_insurance',
    'auto',
    'roadside_assistance',
    'tsa',
    'fraud_protection',
    'financial',
    'travel_portal',
    'insurance',
    'protection',
    'luggage',
    'checked_bag',
    'concierge',
    'companion_certificate',
    'status',
    'premium',
    'diamond',
    'luxury',
    'database',
    'storage',
    'briefcase',
    'business',
    'gym',
    'fitness',
    'percentage',
    'discount',
    'folder',
    'documents',
    'headphones',
    'audio',
    'bed',
    'room',
    'headset',
    'support',
    'dollar',
    'currency',
    'cashback',
    'retail',
    'gas',
    'tv',
    'entertainment',
    'lounge',
    'streaming',
    'transfer_points',
    'trip_insurance',
    'shipping',
    'rewards',
    'grocery',
];

const hasMatchedIcon = computed(() => {
    return supportedIconTypes.includes(iconType.value);
});
</script>
